import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageMeta from '@/components/feature/PageMeta';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedComics from './components/FeaturedComics';
import LatestUpdates from './components/LatestUpdates';

export default function Home() {
  const organizationLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '洞洞杂货铺',
    url: 'https://www.dongdongcomic.com',
    description: '洞洞杂货铺漫画全集免费阅读尽在土豪漫画网，完整章节在线解锁，无需付费即可畅享。',
    sameAs: ['https://weibo.com/dongdongcomic', 'https://space.bilibili.com/dongdongcomic'],
  };

  const websiteLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '洞洞杂货铺漫画',
    url: 'https://www.dongdongcomic.com',
    description: '洞洞杂货铺漫画全集免费阅读，热血、恋爱、搞笑、悬疑、奇幻等类型漫画在线解锁。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.dongdongcomic.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const webpageLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '洞洞杂货铺漫画-首页',
    url: 'https://www.dongdongcomic.com',
    description: '洞洞杂货铺漫画全集免费阅读尽在土豪漫画网，完整章节在线解锁。',
    isPartOf: { '@type': 'WebSite', name: '洞洞杂货铺漫画', url: 'https://www.dongdongcomic.com' },
  };

  return (
    <>
      <PageMeta
        title="洞洞杂货铺漫画-漫画全集免费阅读-土豪漫画网"
        description="洞洞杂货铺漫画全集免费阅读尽在土豪漫画网，完整章节在线解锁，无需付费即可畅享，随时随地追漫无忧。热血、恋爱、搞笑、悬疑、奇幻等多种类型漫画等你来读。"
        keywords="洞洞杂货铺,漫画全集,免费阅读,土豪漫画网,完整章节,在线解锁,热血漫画,恋爱漫画,搞笑漫画,悬疑漫画,奇幻漫画"
        canonicalUrl="https://www.dongdongcomic.com/"
        jsonLd={[organizationLd, websiteLd, webpageLd]}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <FeaturedComics />
          <LatestUpdates />
        </main>
        <Footer />
      </div>
    </>
  );
}